import React, { useState } from 'react'
import { TestimonialsStyle, ColumnA, ColumnB, ColumnRow, ItemTestimonial, TestimonialBox } from './style'

import Img01 from '../../assets/testimonials/1.png'
import Img02 from '../../assets/testimonials/2.png'
import Img03 from '../../assets/testimonials/3.png'

const items = [
  {
    id: 1,
    name: 'Patricia Largacha',
    img: Img01,
    local: 'Bogotá',
    text: 'Aparte de vender un muy buen producto, es tener la posibilidad de llegarle a las personas, asesorar, entender qué quiere y siente el cliente.'
  },
  {
    id: 2,
    name: 'Alejandra Prieto Quevedo',
    img: Img02,
    local: 'Bogotá',
    text: 'El cariño y la calidad humada que nos transmiten me inspira a transmitirlo a mis clientes, tomar sus pedidos y enviárselos con amor.'
  },
  {
    id: 3,
    name: 'Paola Andrea Garzón',
    img: Img03,
    local: 'Tolima',
    text: 'Ser emprendedora O Boticário es tener la oportunidad para mostrar mi experiencia, hacer un cambio y dar un respiro fuera de lo convencional.'
  }
]

export default function Testimonials() {
  const [active, setActive] = useState(1);

  return (
    <TestimonialsStyle>
      <ColumnA>
        <p>Testimonios</p>
      </ColumnA>

      <ColumnB>
        <ColumnRow>
          {items.map(({ id, name, img, local }) =>
            <Item
              key={id}
              id={id}
              name={name}
              img={img}
              local={local}
              isActive={active === id}
              onItemClicked={() => setActive(id)}
            />
          )}
        </ColumnRow>

        <TestimonialBox>
          {items.map(({ id, text }) =>
            active === id ? (
                <p key={id}>
                  {text}
                </p>
              )
            : ''
          )}
        </TestimonialBox>
      </ColumnB>
    </TestimonialsStyle>
  );
}

const Item = ({ id, name, img, local, isActive = false, onItemClicked = () => console.error('You passed no action to the component') }) => {
  return (
    <ItemTestimonial id={id} className={`item-${id} ${isActive ? 'active' : ''}`} onClick={onItemClicked} style={{ backgroundImage: `url(${img})` }}>
      <p>{name}</p>
      <h3>{local}</h3>
    </ItemTestimonial>
  )
}